import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApiBackendClient } from '../../helpers/api_backend_helper';
import { RECEPCION_VEHICULO } from '../../helpers/url_helper';

const useUpdateRecepcionVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const apiBackendClient = new ApiBackendClient();

    const updateRecepcionVehiculo = async (idRecepcion, datosRecepcion) => {
        setLoading(true);
        setError(null);
        try {
            // Transform data to match backend expectations
            const transformedData = {
                ...datosRecepcion,
                // Add any transformations if needed
            };
            console.log('Datos a actualizar:', transformedData);
            const queryParams = `?tenantId=${tenantId}&empresa=${empresa}&departamento=${departamento}`;
            const response = await apiBackendClient.put(`${RECEPCION_VEHICULO}/${idRecepcion}${queryParams}`, {
                recepcionData: transformedData,
                usuario: userInfo?.name
            });
            console.log('Response from API:', response);
            if (response) {
                console.log('Recepción actualizada con éxito');
                return { success: true };
            } else {
                throw new Error(response.message || 'Error al actualizar la recepción');
            }
        } catch (err) {
            const errorMessage = `Failed to update recepcion: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { updateRecepcionVehiculo, loading, error };
};

export default useUpdateRecepcionVehiculo;